import { useLocation } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { getLanguageFromPath, addLanguageToPath, DEFAULT_LANGUAGE, type Language } from '@/components/LanguageWrapper'

export function useLocalizedPath() {
  const location = useLocation()
  const { i18n } = useTranslation()
  
  const currentLanguage = getLanguageFromPath(location.pathname)
  
  const getLocalizedPath = (path: string): string => {
    // If it's an anchor link, keep it as is
    if (path.startsWith('#')) {
      return path
    }
    return addLanguageToPath(path, currentLanguage)
  }
  
  return {
    getLocalizedPath,
    language: currentLanguage
  }
}
